import * as ReactDOM from 'react-dom'

import './css/reset.css'
import './css/variables.css'
import './css/base.css'
import { App } from './App'

ReactDOM.render(<App />, document.getElementById('root'))
